export default __webpack_public_path__ + "static/media/Deelname aan winkel van sinkel.f6b64d3b.jpg";